import React from 'react'

import { useSearchParams } from 'react-router-dom'
import { AllCategories } from './categories/allCategories'
import { SingleCategoryView } from './categories/singleCategory'
import { SingleSubCategoryView } from './subCategories/singleSubCategory'

const Categories: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  return (
    <div>
      {searchParams.get('view') === 'all' ||
        (searchParams.get('view') === null && (
          <AllCategories
            onCategoryClick={(cat) => {
              setSearchParams({
                ...Object.fromEntries(searchParams.entries()),
                view: 'category',
                category: cat._id,
              })
            }}
          />
        ))}

      {searchParams.get('view') === 'category' ? (
        <SingleCategoryView
          cat={searchParams.get('category') ?? ''}
          onSubCategoryClick={(subCat) => {
            setSearchParams({
              ...Object.fromEntries(searchParams.entries()),
              view: 'subcategory',
              category: subCat.category._id,
              subcategory: subCat._id,
            })
          }}
        />
      ) : undefined}

      {searchParams.get('view') === 'subcategory' ? (
        <SingleSubCategoryView
          subCategoryId={searchParams.get('subcategory') ?? ''}
        />
      ) : undefined}
    </div>
  )
}

export default Categories
